<template>
  <div class="wrapper-overlay open-overlay">
        <div class="header-overlay header-overlay-svg">
            <img src="/ext_files/prepaid/f2g/images/logotype_dark.svg">
            <svg v-on:click="closeModal()" class="close-overlay" width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <desc>Created with Sketch.</desc>
                <g id="Icon/Menu/close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path
                        d="M4.38605846,25.6177075 C4.64303181,25.8725692 4.97774286,26 5.31247602,26 C5.6471926,26 5.98188707,25.8725692 6.23889359,25.6177075 L15,16.8528625 L23.7633218,25.6177075 C24.0202952,25.8725692 24.3528502,26 24.6897394,26 C25.024456,26 25.3591505,25.8725692 25.616157,25.6177075 C26.1279477,25.1058277 26.1279477,24.2764407 25.616157,23.7645498 L16.8528372,15.0019165 L25.6139457,6.23707158 C26.1257364,5.72519181 26.1257364,4.89580481 25.6139457,4.38391398 C25.102155,3.87202315 24.2729123,3.8720342 23.7611106,4.38391398 L15,13.1487589 L6.2366823,4.38612565 C5.7248916,3.87424587 4.89564893,3.87424587 4.38384717,4.38612565 C3.87204541,4.89800542 3.87205647,5.72739242 4.38384717,6.23928325 L13.1471669,15.0019165 L4.38605846,23.7667615 C3.87426776,24.2786413 3.87426776,25.1058719 4.38605846,25.6177627 L4.38605846,25.6177075 Z"
                        id="Path"
                        fill="#FFFFFF"
                        fill-rule="nonzero"
                    ></path>
                </g>
            </svg>
        </div>

        <div class="container-overlay overlay-form">
            <div class="overlay-message">
                <img src="/ext_files/prepaid/f2g/images/question@2x.png" class="logo-overlay" />
                <div class="title-overlay1">
                    {{ words['myf2g.disableautorecharge.title'] }}
                </div>
                <div class="title-overlay2">
                    {{ words['myf2g.disableautorecharge.subtitle'] }}
                </div>
                <div class="overlay-button-container ">                       
                    <a v-on:click="closeModal()" >
                        <div class="container-button transparent-btn button-overlay cursor-hand">
                            {{ words['myf2g.disableautorecharge.cancel'] }}                   
                        </div> 
                    </a>
                    <a v-on:click="deleteRecurringPayment()">
                        <div class="container-button button-overlay blue-btn cursor-hand">
                            {{ words['myf2g.disableautorecharge.disable'] }}                        
                        </div>
                    </a>  
                </div>
            </div>
        </div>


  </div>
</template>



<script>
import $ from "jquery";

export default {
  name: "DisableAutoRechargePrompt",
  data() {
    return {
      words: {}
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    hasSavedCard(){
      return this.getCardAndRecurringInfoObject.cardList.length > 0;
    },
    savedCard() {
      if (this.hasSavedCard) {
        return this.getCardAndRecurringInfoObject.cardList[0]
      } else {
        return null;
      }
    },
    getCardAndRecurringInfoObject() {
      return this.$store.state.cardAndRecurringInfoObject;
    },
    token() {
      return this.$store.state.token;
    }
  },
  watch: {

  },
  created(){
    document.body.classList.add("opened-overlay");
  },
  beforeMount() {

    let configWCS = {
      sessionKey: "wcs_myf2gdisableautorecharge",
      axiosConfig: {
      method: "get",
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gdisableautorecharge',
          locale: this.locale
        }
      }
    }

    let self = this;

    this.fetchDataFromWCS(configWCS)
        .then(response => {
          console.log(JSON.stringify(response))
          self.words = response
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          console.log("finally");
        });


  },
  destroyed(){
    document.body.classList.remove("opened-overlay");
  },
  methods: {
    closeModal() {
      this.$store.commit("showDisableAutoRechargePrompt", false);
    },
    deleteRecurringPayment() {
      /* This method is available when saved card exists and there is a reccuring option */

      var self = this;

      self.$store.commit("showLoader");
      this.axios({
        method: "post",
        url: "/epayments/deleteRecurringPayment",
        data: {
          recurringToken: this.savedCard.recurringInfos[0].recurringToken
        }
      })
      .then(response => {
        console.log("deleteRecurringPayment response: " +JSON.stringify(response.data));

        if (response.data.result == "OK") {
          
          var cardAndRecurringInfoObject = {"result":"OK","merchantRef":self.getCardAndRecurringInfoObject.merchantRef,"secToken":self.getCardAndRecurringInfoObject.secToken,"transactionCode":self.getCardAndRecurringInfoObject.transactionCode,"cardList":[{"brand":self.savedCard.brand,"pan":self.savedCard.pan,"datacacheReference":self.savedCard.datacacheReference,"token":self.savedCard.token,"supportsInstalments":self.savedCard.supportsInstalments,"expiryDate":self.savedCard.expiryDate,"recurringInfos":[]}], "isSuccess": true};
          self.$store.commit("setCardAndRecurringInfo", cardAndRecurringInfoObject);
          sessionStorage.setItem('getCardAndRecurringInfo_' + "F2G_" + self.token, JSON.stringify(cardAndRecurringInfoObject));

          self.$store.commit("hideLoader");
          self.$store.commit("showDisableAutoRechargePrompt", false);
          self.$store.commit("showAutoRechargeModal", false);


          self.$store.commit("isDeleteReccuringAction",true);

          self.$store.commit("showSuccessComponent",true);

        } else {
          console.log("error in deleteRecurringPayment");
          self.$store.commit("hideLoader");
          self.$store.commit("showErrorComponent", true);
        }
      })
      .catch(error => {
        console.error("deleteRecurringPayment responded with error: " + error);
        self.$store.commit("hideLoader");
        self.$store.commit("showErrorComponent", true);
      });
    }

  }
  
}
</script>